import React from 'react';

const getRadarPoints = (values, size = 340, levels = 5) => {
    const center = size / 2;
    const radius = size * 0.33;
    const entries = values.map((item, index) => {
        const angle = ((Math.PI * 2) / values.length) * index - Math.PI / 2;
        const valueRadius = (item.value / 10) * radius;
        const x = center + Math.cos(angle) * valueRadius;
        const y = center + Math.sin(angle) * valueRadius;
        const labelRadius = radius + 44;
        const lx = center + Math.cos(angle) * labelRadius;
        const ly = center + Math.sin(angle) * labelRadius;

        return { ...item, x, y, lx, ly, angle };
    });

    const polygonPoints = entries.map(({ x, y }) => `${x},${y}`).join(' ');
    const grid = Array.from({ length: levels }, (_, levelIndex) => {
        const scale = (levelIndex + 1) / levels;
        return entries.map(({ angle }) => {
            const x = center + Math.cos(angle) * radius * scale;
            const y = center + Math.sin(angle) * radius * scale;
            return `${x},${y}`;
        }).join(' ');
    });

    return { center, radius, entries, polygonPoints, grid };
};

const DemoRiasecCard = ({ riasec }) => {
    const values = riasec.labels.map((label) => ({
        ...label,
        value: riasec.values[label.code] || 0
    }));
    const { center, radius, entries, polygonPoints, grid } = getRadarPoints(values);

    return (
        <div className="rounded-[2rem] border border-white/60 bg-white/80 backdrop-blur-xl p-6 md:p-8 shadow-[0_12px_40px_rgba(0,0,0,0.05)] h-full">
            <h2 className="text-2xl md:text-3xl font-black text-[#171717] brand-font">{riasec.title}</h2>

            <div className="mt-8 flex flex-col items-center">
                <div className="w-full overflow-x-auto">
                    <svg viewBox="0 0 340 340" className="mx-auto min-w-[320px] max-w-[420px] w-full">
                        {grid.map((points, index) => (
                            <polygon
                                key={index}
                                points={points}
                                fill="none"
                                stroke="rgba(23,23,23,0.12)"
                                strokeWidth="1"
                            />
                        ))}

                        {entries.map(({ x, y }, index) => (
                            <line
                                key={index}
                                x1={center}
                                y1={center}
                                x2={x + ((x - center) / (radius || 1)) * (radius - Math.hypot(x - center, y - center) + 2)}
                                y2={y + ((y - center) / (radius || 1)) * (radius - Math.hypot(x - center, y - center) + 2)}
                                stroke="rgba(23,23,23,0.12)"
                                strokeWidth="1"
                            />
                        ))}

                        <polygon
                            points={polygonPoints}
                            fill="rgba(243,119,65,0.22)"
                            stroke="rgba(243,119,65,0.95)"
                            strokeWidth="3"
                            strokeLinejoin="round"
                        />

                        {entries.map(({ x, y, value, code }, index) => (
                            <g key={`${code}-${index}`}>
                                <circle cx={x} cy={y} r="5.5" fill="#F37741" stroke="#fff" strokeWidth="2" />
                                <text x={x} y={y - 12} textAnchor="middle" className="fill-[#171717] text-[10px] font-bold">
                                    {value}
                                </text>
                            </g>
                        ))}

                        {entries.map(({ lx, ly, title, subtitle, code }) => (
                            <g key={code}>
                                <text x={lx} y={ly - 4} textAnchor="middle" className="fill-[#171717] text-[11px] font-bold">
                                    {title}
                                </text>
                                <text x={lx} y={ly + 12} textAnchor="middle" className="fill-[#525252] text-[10px]">
                                    ({subtitle})
                                </text>
                            </g>
                        ))}
                    </svg>
                </div>

                <div className="mt-4 text-center max-w-xl">
                    <h3 className="text-2xl md:text-3xl font-black brand-font text-[#171717]">{riasec.subtitle}</h3>
                    <p className="mt-3 text-sm md:text-base text-gray-700 leading-relaxed brand-text">{riasec.description}</p>
                </div>
            </div>
        </div>
    );
};

export default DemoRiasecCard;
